import React, { useCallback, useEffect, useState } from 'react';
import { Box, Paper, Typography, TextField, Button, Grid } from '@mui/material';
import AxiosInstance from '../../../../server/AxioInstance';
import MultiSelectAutocomplete from '../../../common/autoComplete/MultiSelectAutocomplete';
import { useSnackbar } from '../../../../shared/context';

export default function BodyCreateDocument() {
  const [getOptionsMacroSector, setOptionsMacroSector] = useState([]);
  const [getOptionsResponsible, setOptionsResponsible] = useState([]);
  const [getDisableResponsible, setDisableResponsible] = useState(true);
  const [getOptionsApproved, setOptionsApproved] = useState([]);
  const [getOptionsSector, setOptionsSector] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { showSnackbar } = useSnackbar();
  const [getFormData, setFormData] = useState({
    title: '',
    about: '',
    fileDoc: null,
    filePdf: null,
    approve: [],
    responsible: [],
    sector: [],
    macroSector: [],
  });
  const [fileNameDoc, setFileNameDoc] = useState('');
  const [fileNamePdf, setFileNamePdf] = useState('');

  const handleFileChangeDocs = (event) => {
    const file = event.target.files[0];
    setFileNameDoc(file.name);
    setFormData((prevData) => ({ ...prevData, fileDoc: file }));
  };

  const handleFileChangePdf = (event) => {
    const file = event.target.files[0];
    setFileNamePdf(file.name);
    setFormData((prevData) => ({ ...prevData, filePdf: file }));
  };

  const handleButtonClick = (event) => {
    const id = 'fileInput' + event.target.id;
    document.getElementById(id).click();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeApproved = (e, value) => {
    setFormData((prevData) => ({ ...prevData, responsible: [] }));
    setFormData((prevData) => ({ ...prevData, approve: value }));
    getResponsible(value);
    setDisableResponsible(value.length === 0);
  };

  const handleChangeResponsible = (e, value) => {
    setFormData((prevData) => ({ ...prevData, responsible: value }));
  };

  const handleChangeMacroSector = (e, value) => {
    setFormData((prevData) => ({ ...prevData, macroSector: value }));
    getSector(value);
  };

  const handleChangeSector = (e, value) => {
    setFormData((prevData) => ({ ...prevData, sector: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (getFormData.approve.length === 0) {
      // Adicione lógica para lidar com o erro de validação, por exemplo, exibir uma mensagem de erro.
      console.error('Campo "approve" é obrigatório.');
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append('title', getFormData.title);
    formDataToSend.append('about', getFormData.about);
    formDataToSend.append('login', localStorage.getItem('@gedy:user'));
    formDataToSend.append('fileDoc', getFormData.fileDoc);
    formDataToSend.append('filePdf', getFormData.filePdf);
    formDataToSend.append('approve', JSON.stringify(getFormData.approve));
    formDataToSend.append('sector', JSON.stringify(getFormData.sector));
    formDataToSend.append('responsible', JSON.stringify(getFormData.responsible));

    showSnackbar({
      vertical: 'top',
      horizontal: 'right',
      message: 'Aguarde o envio do documento.',
      variant: 'info',
    });
    setIsLoading(true);

    try {
      await AxiosInstance.post('/manipulate-documents/upload', formDataToSend, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      showSnackbar({
        vertical: 'top',
        horizontal: 'right',
        message: 'Sucesso ao enviar a requisição:',
        variant: 'success',
      });
      setFormData({
        title: '',
        about: '',
        file: null,
        approve: [],
        responsible: [],
        sector: [],
        macroSector: [],
      });
      setIsLoading(false);
    } catch (error) {
      showSnackbar({
        vertical: 'top',
        horizontal: 'right',
        message: 'Erro ao enviar a requisição: ' + error.message,
        variant: 'error',
      });
      setIsLoading(false);
    }
  };

  const getApproved = useCallback(async () => {
    try {
      const result = await AxiosInstance.get('/data-input/approved');
      setOptionsApproved(result.data);
    } catch (error) {
      console.error('Erro ao pegar dados a requisição:', error);
    }
  }, []);

  const getMacroSector = useCallback(async () => {
    try {
      const result = await AxiosInstance.get('/data-input/macro-sector');
      setOptionsMacroSector(result.data);
    } catch (error) {
      console.error('Erro ao pegar dados a requisição:', error);
    }
  }, []);

  const getSector = useCallback(
    async (value) => {
      try {
        const result = await AxiosInstance.post('/data-input/sector', value);
        setOptionsSector(result.data);
      } catch (error) {
        console.error('Erro ao pegar dados a requisição:', error);
      }
  // eslint-disable-next-line
    },
    [getFormData.macroSector],
  );

  const getResponsible = useCallback(
    async (value) => {
      try {
        const result = await AxiosInstance.post('/data-input/responsible', value);
        setOptionsResponsible(result.data);
      } catch (error) {
        console.error('Erro ao pegar dados a requisição:', error);
      }
  // eslint-disable-next-line
    },
    [getFormData.macroSector],
  );

  useEffect(() => {
    getApproved();
    getMacroSector();
    getResponsible();
  }, [getApproved, getMacroSector, getResponsible]);

  return (
    <form onSubmit={handleFormSubmit} method="POST">
      <Box p={2} component={Paper}>
        <Box>
          <Typography variant="h4" mb={1}>
            Criar um novo Documento
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                label="Título do Documento"
                variant="outlined"
                id="title"
                name="title"
                fullWidth
                margin="normal"
                required
                disabled={isLoading}
                value={getFormData.title}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                label="Sobre o Documento"
                variant="outlined"
                id="about"
                name="about"
                multiline
                rows={4}
                fullWidth
                margin="normal"
                required
                disabled={isLoading}
                value={getFormData.about}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6}>
              <input
                id="fileInputdocs"
                type="file"
                accept=""
                name="fileInputdocs"
                onChange={handleFileChangeDocs}
                style={{ display: 'none' }}
                required
                disabled={isLoading}
              />
              <Button
                id="docs"
                variant="contained"
                color="primary"
                onClick={handleButtonClick}
                fullWidth
                disabled={isLoading}
              >
                Upload do documento
              </Button>
              <Typography variant="body2">{fileNameDoc}</Typography>
            </Grid>
            <Grid item xs={6}>
              <input
                id="fileInputpdf"
                type="file"
                accept=".pdf"
                onChange={handleFileChangePdf}
                style={{ display: 'none' }}
                required
              />
              <Button
                id="pdf"
                variant="contained"
                color="error"
                onClick={handleButtonClick}
                fullWidth
                disabled={isLoading}
              >
                Upload do PDF
              </Button>
              <Typography variant="body2">{fileNamePdf}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <MultiSelectAutocomplete
                value={getFormData.approve}
                options={getOptionsApproved}
                label="Selecione quem são os aprovadores"
                onChange={(event, selectValues) => handleChangeApproved(event, selectValues)}
                required={false}
                disabled={isLoading}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MultiSelectAutocomplete
                value={getFormData.responsible}
                options={getOptionsResponsible}
                label="Selecione quem serão os responsaveis"
                onChange={(event, selectValues) => handleChangeResponsible(event, selectValues)}
                required={false}
                disabled={getDisableResponsible && isLoading}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MultiSelectAutocomplete
                value={getFormData.macroSector}
                options={getOptionsMacroSector}
                label="Selecione os setores macros"
                onChange={(event, selectValues) => handleChangeMacroSector(event, selectValues)}
                required={false}
                disabled={isLoading}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MultiSelectAutocomplete
                value={getFormData.sector}
                options={getOptionsSector}
                label="Selecione os setores"
                onChange={(event, selectValues) => handleChangeSector(event, selectValues)}
                required={false}
                disabled={isLoading}
              />
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ marginLeft: 'auto' }} my={2}>
          <Button type="submit" variant="contained" color="primary">
            criar documento
          </Button>
        </Box>
      </Box>
    </form>
  );
}
